import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { cardWidth } from "@utils/ui-utils";
/**
 * A container for the tiles, for example the projects and groups tiles. It makes sure that the tiles are
 * aligned properly.
 */
export function TilesContainer(t0) {
  const $ = _c(6);
  const {
    children,
    dataTestId,
    itemWidth
  } = t0;
  const t1 = itemWidth || cardWidth;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      display: "flex",
      flexWrap: "wrap",
      columnGap: "20px",
      "& > *": {
        width: t1,
        flexGrow: 0
      }
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== dataTestId || $[4] !== t2) {
    t3 = <Box component="div" data-testid={dataTestId} sx={t2}>{children}</Box>;
    $[2] = children;
    $[3] = dataTestId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}